import React from 'react';
import { TextField, Button, Paper, Typography, Grid, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Filtros } from '../services/api';
import { colors } from '../theme/expertiseTheme';

/**
 * Componente de formulário de filtros
 */
type Props = {
  filtros: Filtros;
  onChange: (f: Filtros) => void;
  onBuscar: () => void;
  loading: boolean;
};

const FormularioFiltros: React.FC<Props> = ({ filtros, onChange, onBuscar, loading }) => {
  const handleChange =
    (campo: keyof Filtros) => (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange({
        ...filtros,
        [campo]: event.target.value,
      });
    };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onBuscar();
  };

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        mb: 3, 
        border: `1px solid ${colors.border}`,
        borderRadius: '16px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <SearchIcon sx={{ color: colors.primary, fontSize: 24 }} />
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: colors.dark,
          }}
        >
          Filtros de Busca
        </Typography>
      </Box>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs={12} md={3}>
            <Typography 
              sx={{ 
                fontSize: '0.875rem', 
                fontWeight: 500, 
                color: colors.text.secondary,
                mb: 1 
              }}
            >
              Conta ID
            </Typography>
            <TextField
              fullWidth
              value={filtros.conta_id}
              onChange={handleChange('conta_id')}
              placeholder="Ex: 81043"
              required
              disabled={loading}
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.light,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography 
              sx={{ 
                fontSize: '0.875rem', 
                fontWeight: 500, 
                color: colors.text.secondary,
                mb: 1 
              }}
            >
              Data Início
            </Typography>
            <TextField
              fullWidth
              type="date"
              value={filtros.data_inicio}
              onChange={handleChange('data_inicio')}
              required
              disabled={loading}
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.light,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography 
              sx={{ 
                fontSize: '0.875rem', 
                fontWeight: 500, 
                color: colors.text.secondary,
                mb: 1 
              }}
            >
              Data Fim
            </Typography>
            <TextField
              fullWidth
              type="date"
              value={filtros.data_fim}
              onChange={handleChange('data_fim')}
              required
              disabled={loading}
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.light,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography 
              sx={{ 
                fontSize: '0.875rem', 
                fontWeight: 500, 
                color: colors.text.secondary,
                mb: 1 
              }}
            >
              Data de Processamento
            </Typography>
            <TextField
              fullWidth
              type="date"
              value={filtros.dataProcessamento || ''}
              onChange={handleChange('dataProcessamento')}
              disabled={loading}
              size="small"
              placeholder="Opcional"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.light,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={loading}
              startIcon={<SearchIcon />}
              sx={{ 
                height: '40px',
                backgroundColor: colors.accent,
                color: colors.dark,
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#c9e835',
                },
                '&:disabled': {
                  backgroundColor: colors.border,
                  color: colors.text.light,
                },
              }}
            >
              {loading ? 'Buscando...' : 'Aplicar'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default FormularioFiltros;
